import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

// Sent by forceLogout, also while a session switch holds the other requests back:
// the switch only ends once this logout is done
export function logout() {
  return restApiClient
    .url(constructApiUrl(API.auth.logout.url, null))
    .options({ bypassSessionSwitch: true })
    .post()
}

export function terminateSession() {
  return restApiClient.url(constructApiUrl(API.auth.terminateSession.url, null)).post()
}
